import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "modal" };
const _hoisted_2 = { class: "content" };
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "text" };
const _hoisted_5 = {
    key: 0,
    class: "carousel"
};
const _hoisted_6 = { class: "carousel-img" };
const _hoisted_7 = ["src"];
import { ref, computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'modal',
    props: {
        caseData: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const dialogVisible = ref(false);
        const imageList = computed(() => {
            if (!props.caseData?.images)
                return [];
            try {
                return JSON.parse(props.caseData.images);
            }
            catch {
                return [];
            }
        });
        const show = () => {
            dialogVisible.value = true;
        };
        __expose({ show });
        return (_ctx, _cache) => {
            const _component_el_carousel_item = _resolveComponent("el-carousel-item");
            const _component_el_carousel = _resolveComponent("el-carousel");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_dialog, {
                    modelValue: dialogVisible.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((dialogVisible).value = $event)),
                    title: "案例展示",
                    center: "",
                    style: { "width": "500px" }
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.caseData?.companyName || ''), 1),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.caseData?.content || ''), 1),
                            (imageList.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_el_carousel, {
                                        trigger: "click",
                                        interval: 5000,
                                        height: "300px"
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, (img, index) => {
                                                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_6, [
                                                            _createElementVNode("img", {
                                                                src: img,
                                                                alt: "案例图片"
                                                            }, null, 8, _hoisted_7)
                                                        ])
                                                    ]),
                                                    _: 2
                                                }, 1024));
                                            }), 128))
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
